module.exports = __webpack_public_path__ + "img/arrow-circle-left-red.5479aa20.svg";